import React from 'react'
import authorstepone from './AuthormobilStepOne.module.css'

export default function AuthormobilStepOne() {
    return (
        <>
            <div className={authorstepone.stepperOne}>
                <div className='row'>
                    <div className='col-7'>
                        <h3> Author Registration </h3>
                    </div>
                    <div className='col-5'>
                        <div className={authorstepone.profileBox}>
                            <div className={authorstepone.profileImg}>
                                <div className={authorstepone.profileImginner}>
                                    <img src="/static/media/lady-img.965cec88308ed5853d74.png" className="img-fluid w-100 h-100 rounded-circle" />
                                </div>
                            </div>
                            <div className={authorstepone.profileeditBox}>
                                <input type="file" className={authorstepone.profilechooseInput} accept=".png, .jpg, .jpeg" />
                                <label className={authorstepone.profileLabel} for="imageUpload" />
                            </div>
                        </div>
                    </div>
                </div>
                <h6> Sign up to join </h6>
                <h5> Author Information </h5>
                <div className='row'>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="text" className={`${authorstepone.oneInput} form-control`} placeholder='First Name' />
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="text" className={`${authorstepone.oneInput} form-control`} placeholder='Last Name' />
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="email" className={`${authorstepone.oneInput} form-control`} placeholder='Email Address' />
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="number" className={`${authorstepone.oneInput} form-control`} placeholder='Phone' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
